























































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal/modal-config.model";
import { computed } from "@vue/composition-api";
import { SharedState } from "@/common/state";
export default Vue.extend({
  components: {
    Modal,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem",
      backdropDismiss: true,
    };
    // @ts-ignore
    const feature_id = computed(() => props.modalData.key);

    const feature = computed(
      () => SharedState.premium_features.value[feature_id.value]
    );

    return {
      feature,
      config,
    };
  },
});
